<p class="usage-chart-axis">
  <b>{{ 'usage.report.details.chart.label.yAxis' | transloco }}</b>
</p>
<div class="usage-chart">
  <canvas
    baseChart
    [type]="chart.type"
    [data]="chart.data"
    [options]="chart.options"
    [legend]="false"
  >
  </canvas>
</div>
<p class="usage-chart-axis x-axis">
  <b>{{ 'usage.report.details.chart.label.xAxis' | transloco }}</b>
</p>
